import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-changer-container" }
const _hoisted_2 = { class: "date-header" }

import { useStore } from 'vuex';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/en';
import 'dayjs/locale/he';

import { useRTL } from '@/composables/useRTL';


export default /*@__PURE__*/_defineComponent({
  __name: 'DateChanger',
  setup(__props) {

dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

const store = useStore();
const rtl = useRTL();

const handleBackDate = () => {
  store.commit('backDate');
};

const handleNextDate = () => {
  store.commit('nextDate');
};

const formatDate = () => {
  return dayjs.tz(store.state.date, 'Asia/Jerusalem').locale(store.state.locale).format('D MMMM YYYY');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-spanner", { 'with-sidebar': _unref(store).state.view === 'sidebar', 'dark-mode': _unref(store).state.dark }]),
    id: "containerSpanner"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", {
        class: _normalizeClass(["text-container", { 'dark-mode': _unref(store).state.dark }])
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_unref(rtl) ? 'fas fa-chevron-right' : 'fas fa-chevron-left'),
          onClick: handleBackDate
        }, null, 2),
        _createElementVNode("div", _hoisted_2, _toDisplayString(formatDate()), 1),
        _createElementVNode("i", {
          class: _normalizeClass(_unref(rtl) ? 'fas fa-chevron-left' : 'fas fa-chevron-right'),
          onClick: handleNextDate
        }, null, 2)
      ], 2)
    ])
  ], 2))
}
}

})